import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import OrganizationHeader from "../../../../components/sites/home/reusable/OrganizationHeader";
import OrganizationPledges from "../../../../components/sites/home/pledges/OrganizationPledges";

const Pledges = ({
  orgName,
  orgObj,
  setOrgObj,
  userData,
  setLoggedInUserData,
  pledgesArray,
  pledgesError,
}) => {
  // use t function where ever hard coded text is used
  const { t } = useTranslation();

  // navigate
  const navigate = useNavigate();

  // tippy content
  const content = t("pledge.back_to_home");

  // navigation on back button click
  const handleGoBack = () => {
    navigate(`/sites/${orgName}`);
  };

  // scroll to top
  useEffect(() => {
    document.querySelector(".home-content")?.scrollTo(0, 0);
  }, []);

  return (
    <div className="cards-container single-card">
      <div className="custom-card single-card">
        <OrganizationHeader
          userData={userData}
          setLoggedInUserData={setLoggedInUserData}
          orgObj={orgObj}
          setOrgObj={setOrgObj}
          content={content}
          handleGoBack={handleGoBack}
        />

        <OrganizationPledges
          pledgesArray={pledgesArray}
          pledgesError={pledgesError}
          orgName={orgName}
          orgObj={orgObj}
          content={content}
          handleGoBack={handleGoBack}
        />
      </div>
    </div>
  );
};

export default Pledges;
